<label *ngIf="label" class="go-form__label">{{ label }}</label>
<div class="go-form__input-group"
     [ngClass]="{
       'go-form__input-group--sm': size === 'small',
       'go-form__input-group--lg': size === 'large'
     }">
  <ng-content select="[goInputGroupPrepend]"></ng-content>
  <ng-content></ng-content>
  <ng-content select="[goInputGroupAppend]"></ng-content>
</div>
